var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.002,
    height: 95.999,
    viewBox: "0 0 96.002 95.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-10197,96a47.7,47.7,0,0,1-18.684-3.772,47.842,47.842,0,0,1-15.259-10.286,47.833,47.833,0,0,1-10.286-15.257A47.7,47.7,0,0,1-10245,48a47.709,47.709,0,0,1,3.772-18.685,47.835,47.835,0,0,1,10.286-15.258,47.841,47.841,0,0,1,15.259-10.287A47.7,47.7,0,0,1-10197,0a47.7,47.7,0,0,1,18.684,3.772,47.843,47.843,0,0,1,15.258,10.287,47.843,47.843,0,0,1,10.287,15.258A47.709,47.709,0,0,1-10149,48a47.7,47.7,0,0,1-3.772,18.683,47.842,47.842,0,0,1-10.287,15.257,47.845,47.845,0,0,1-15.258,10.286A47.7,47.7,0,0,1-10197,96Zm-26.7-53.386a5.427,5.427,0,0,0-3.846,1.585,5.43,5.43,0,0,0-1.616,3.855,5.423,5.423,0,0,0,1.583,3.869l19.489,19.651a5.431,5.431,0,0,0,3.88,1.615,5.437,5.437,0,0,0,3.808-1.545l35.24-34.268a5.429,5.429,0,0,0,1.656-3.9v-.028a5.436,5.436,0,0,0-1.548-3.8,5.412,5.412,0,0,0-3.9-1.653h-.031a5.425,5.425,0,0,0-3.792,1.545l-31.363,30.5-15.682-15.81A5.422,5.422,0,0,0-10223.7,42.613Z",
    transform: "translate(10245.001)",
    fill: "#734bd1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickmark);
export default __webpack_public_path__ + "static/media/Tickmark.47e1b00f4795df8260d86e8aaecfd75c.svg";
export { ForwardRef as ReactComponent };